module.exports = __webpack_public_path__ + "static/media/4e_website_logo_sup_bec.71c94043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4e_website_logo_sup_bec.jpg
// module id = 58
// module chunks = 0